import { StorageConfigurationServiceType } from '@/services/api/storageConfigurationApiArea/interface';
import { StorageConfigurationService } from '@/services/api/storageConfigurationApiArea/StorageConfigurationService';

/** Метод storageConfigurationApiArea возвращает экземпляр StorageConfigurationService. По необходимости можно реализовать синглтон. **/
export const storageConfigurationApiArea: {
  (): StorageConfigurationServiceType;
} = () => new StorageConfigurationService();

// Экспорт типов для удобства использования
export * from '@/services/api/storageConfigurationApiArea/types';
export type { StorageConfigurationServiceType } from '@/services/api/storageConfigurationApiArea/interface';
